/**
 * Flag emoji from an ISO 3166-1 alpha-2 country code (or the "EU" bloc code).
 * Same approach as MoonPhoneField's country picker: map each letter to its
 * Regional Indicator Symbol. Returns "" for anything that isn't a 2-letter code.
 *
 * Note: flag emoji render on iOS and web; Android may fall back to the two
 * letters depending on the system font — acceptable, still legible.
 */
export function flagFromIso(iso: string): string {
  const upper = iso.trim().toUpperCase();
  if (upper.length !== 2) return "";
  return String.fromCodePoint(
    ...[...upper].map((c) => 127397 + c.charCodeAt(0)),
  );
}
